// extracted by mini-css-extract-plugin
module.exports = {"banner":"EnvironmentBanner_banner__ZWrai"};